import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectTemplateList = createSelector(
  [
    (store: RootState) => store.templateList.templates,
    (store: RootState) => store.templateList.searchText,
  ],
  (templates, searchText) => templates.filter(
    ({ name }) => {
      if (
        searchText
        && !name?.toLowerCase().includes(searchText?.toLowerCase().trim())
      ) {
        return false;
      }
      return true;
    })
);
